import { render, staticRenderFns } from "./FeatDetails.vue?vue&type=template&id=b6d386ba&"
import script from "./FeatDetails.vue?vue&type=script&lang=js&"
export * from "./FeatDetails.vue?vue&type=script&lang=js&"
import style0 from "./FeatDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports